import { Directive, ElementRef, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[selectOnFocus]',
  host: {
    '(focus)': 'onFocus()',
  },
})
export class SelectOnFocusDirective {
  private elementRef = inject(ElementRef);
  private platformId = inject(PLATFORM_ID);

  onFocus(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.elementRef.nativeElement.select();
  }
}
